"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f102 = void 0;
exports.f102 = {
    "fa": [
        "Arab"
    ],
    "faa": [
        "Latn"
    ],
    "fab": [
        "Latn"
    ],
    "fad": [
        "Latn"
    ],
    "faf": [
        "Latn"
    ],
    "fag": [
        "Latn"
    ],
    "fah": [
        "Latn"
    ],
    "fai": [
        "Latn"
    ],
    "faj": [
        "Latn"
    ],
    "fak": [
        "Latn"
    ],
    "fal": [
        "Latn"
    ],
    "fam": [
        "Latn"
    ],
    "fan": [
        "Latn"
    ],
    "fap": [
        "Latn"
    ],
    "far": [
        "Latn"
    ],
    "fau": [
        "Latn"
    ],
    "fax": [
        "Latn"
    ],
    "fay": [
        "Arab"
    ],
    "faz": [
        "Arab"
    ],
    "fbl": [
        "Latn"
    ],
    "fcs": [
        "Zxxx"
    ],
    "fer": [
        "Latn"
    ],
    "ff": [
        "Latn",
        "Adlm",
        "Arab"
    ],
    "ffi": [
        "Latn"
    ],
    "ffm": [
        "Latn",
        "Arab"
    ],
    "fgr": [
        "Latn"
    ],
    "fi": [
        "Latn",
        "Brai"
    ],
    "fia": [
        "Arab",
        "Copt",
        "Latn"
    ],
    "fie": [
        "Latn"
    ],
    "fil": [
        "Latn",
        "Tglg"
    ],
    "fip": [
        "Latn"
    ],
    "fir": [
        "Latn"
    ],
    "fit": [
        "Latn"
    ],
    "fiw": [
        "Latn"
    ],
    "fj": [
        "Latn"
    ],
    "fkk": [
        "Latn"
    ],
    "fkv": [
        "Latn"
    ],
    "fla": [
        "Latn"
    ],
    "flh": [
        "Latn"
    ],
    "fli": [
        "Latn"
    ],
    "fll": [
        "Latn"
    ],
    "fln": [
        "Latn"
    ],
    "flr": [
        "Latn"
    ],
    "fly": [
        "Latn"
    ],
    "fmp": [
        "Latn"
    ],
    "fmu": [
        "Deva"
    ],
    "fnb": [
        "Latn"
    ],
    "fng": [
        "Latn"
    ],
    "fni": [
        "Latn"
    ],
    "fo": [
        "Latn"
    ],
    "fod": [
        "Latn"
    ],
    "foi": [
        "Latn"
    ],
    "fom": [
        "Latn"
    ],
    "fon": [
        "Latn"
    ],
    "for": [
        "Latn"
    ],
    "fos": [
        "Latn"
    ],
    "fpe": [
        "Latn"
    ],
    "fqs": [
        "Latn"
    ],
    "fr": [
        "Latn",
        "Brai",
        "Dupl"
    ],
    "frc": [
        "Latn"
    ],
    "frd": [
        "Latn"
    ],
    "frk": [
        "Latn"
    ],
    "frm": [
        "Latn"
    ],
    "fro": [
        "Latn"
    ],
    "frp": [
        "Latn"
    ],
    "frq": [
        "Latn"
    ],
    "frr": [
        "Latn"
    ],
    "frs": [
        "Latn"
    ],
    "frt": [
        "Latn"
    ],
    "fse": [
        "Zxxx"
    ],
    "fsl": [
        "Zxxx"
    ],
    "fss": [
        "Zxxx"
    ],
    "fub": [
        "Arab",
        "Latn"
    ],
    "fud": [
        "Latn"
    ],
    "fue": [
        "Latn"
    ],
    "fuf": [
        "Latn",
        "Adlm",
        "Arab"
    ],
    "fuh": [
        "Arab",
        "Latn"
    ],
    "fui": [
        "Latn"
    ],
    "fuj": [
        "Zyyy"
    ],
    "fum": [
        "Latn"
    ],
    "fun": [
        "Latn"
    ],
    "fuq": [
        "Latn"
    ],
    "fur": [
        "Latn"
    ],
    "fut": [
        "Latn"
    ],
    "fuu": [
        "Latn"
    ],
    "fuv": [
        "Latn",
        "Arab"
    ],
    "fuy": [
        "Latn"
    ],
    "fvr": [
        "Latn"
    ],
    "fwa": [
        "Latn"
    ],
    "fwe": [
        "Latn"
    ],
    "fy": [
        "Latn"
    ]
};
